import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import classNames from 'classnames';
import { DropdownItem } from '../../components/DropdownItem/DropdownItem';
import { LocationType } from '../../models';
import { ABUtils, TrackingUtils } from '../../utils';

export class PreviousSearchItemMobile extends PureComponent {
    onClick = () => {
        const { value, onClickItem } = this.props;
        this.trackClickEvent();
        onClickItem(value);
    }

    trackClickEvent = () => {
        const { index, trackingId } = this.props;
        const label = `search_recent_${index + 1}`;
        const trackingIdAction = !isEmpty(trackingId) ? `_${trackingId}` : '';
        TrackingUtils.trackEvent(`recent_search${trackingIdAction}`, label, 'home');
    }

    render() {
        const { isCssVariationMobile } = ABUtils.getABs();
        const { value } = this.props;
        const isAirport = value.type === LocationType.AIRPORT;
        const icon = classNames('odf-icon-bidi', { ['odf-icon-flight-right']: isAirport, ['odf-icon-city']: !isAirport });
        return (
            <DropdownItem
                onClick={this.onClick}
                iconClass={icon}
                isFixedWidth
                iataCode={isCssVariationMobile ? value.iata : ''}
            >
                <span className="odf-display-inline-flex">
                    <span>{value.city}</span>
                    {isAirport && !isCssVariationMobile ? <span className="odf-space-outer-left-xs">${value.iata}</span>: ''}
                    <span className="odf-space-outer-right-xs">,</span>
                    <span>{value.country}</span>
                </span>
            </DropdownItem>
        );
    }
}

PreviousSearchItemMobile.propTypes = {
    index: PropTypes.number.isRequired,
    onClickItem: PropTypes.func.isRequired,
    value: PropTypes.object.isRequired,
    trackingId: PropTypes.string,
};

PreviousSearchItemMobile.defaultProps = {
    trackingId: '',
};
